import { useQuery } from "react-query";

import { ApiResult } from "../api/apiResult";
import { IpdbField, fetchPlayZoneFields } from "../api/ipdp";

export const PLAY_ZONE_FIELDS_QUERY_KEY = "fetchPlayZoneFields";

///hook to fetch ipdb fields
export default function usePlayZoneFields(
  modelSource: string,
  zones: string[]
): ApiResult<IpdbField[]> {
  const { data, isLoading, isError, refetch } = useQuery<IpdbField[]>(
    [PLAY_ZONE_FIELDS_QUERY_KEY, modelSource, zones],
    () => fetchPlayZoneFields(modelSource, zones),
    {
      enabled: false
    }
  );

  return {
    data,
    isLoading,
    isError,
    refetch
  };
}
